function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.51436 4.7065C7.87845 4.03879 6.88131 3.80001 5.98879 4.18304L1.39568 6.15423C0.23461 6.65252 -0.309739 8.01443 0.179847 9.19614L0.738123 10.5437C1.22771 11.7254 2.56583 12.2794 3.72691 11.7811L8.32002 9.80992C9.21965 9.42383 9.74903 8.51925 9.71407 7.58175L6.41837 8.97937L6.41377 8.97117L3.1441 10.3744C2.74637 10.5451 2.28798 10.3553 2.12027 9.95049L1.562 8.60298C1.39429 8.19817 1.58076 7.73164 1.97849 7.56095L5.44238 6.07438L8.51436 4.7065Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.50552 4.18482L9.26346 2.24882C9.51924 2.14474 9.81622 2.2655 9.92679 2.51854L10.6564 4.18818C10.7669 4.44121 10.6492 4.73071 10.3935 4.83479L9.47876 5.20698L9.50008 5.23076L3.86682 7.53282C4.42224 8.21624 5.38607 8.49118 6.23612 8.1453L10.9941 6.20929C12.0172 5.79299 12.488 4.63499 12.0458 3.62284L11.3162 1.9532C10.8739 0.941042 9.68596 0.458008 8.66284 0.874313L3.9049 2.81031C3.03327 3.16498 2.56246 4.05798 2.71564 4.94049L4.36495 4.27156C4.40533 4.23598 4.45245 4.20641 4.50552 4.18482Z",
  fill: "currentColor"
});

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.a5cb8c85.svg";
export { ForwardRef as ReactComponent };